import React from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import messages from './DateOfBirth.messages';
import FormField from '../../components/FormField/';
import { numbersOnly, getAge } from '../../helpers/helpers';
import normalizer from '../../helpers/inputNormalizer';
import months from '../../helpers/months';
import monthsDE from '../../helpers/monthsDE';
import { getCountryCode } from '../../lendingAPI/lendingAPISelector';

function getMonthNamesByLocale(props) {
    if (props.country_code === 'de') {
        return monthsDE;
    } else {
        return months;
    }
}

function DateOfBirth(props) {
    const { handleMonthSelectChange, dob, intl } = props;

    const maskedDay = normalizer(dob.dd, numbersOnly);
    const maskedYear = normalizer(dob.yy, numbersOnly);

    let date = `${dob.yy.value}-${dob.mm.value}-${dob.dd.value}`;

    date = date.split('-').filter((d) => d).length === 3 ? date : null;

    const customerAgeIsInvalid = date && getAge(date) < 18;
    const customerInvalidAgeErrorMessage = customerAgeIsInvalid
        ? messages.belowLegalAgeError.id
        : null;

    const dateOfBirthFields = [
        {
            type: 'input',
            field: dob.dd,
            className:
                'dob dob_dd no-pad left-field fs-exclude dd-privacy-mask',
            inputAttributes: {
                value: maskedDay,
                maxLength: '2',
                pattern: '\\d*',
                placeholder: intl.formatMessage({ ...messages.dayPlaceholder }),
                whenBlur: (event) => {
                    if (event?.target?.value?.length > 0) {
                        tracking.ampli.formFieldCompleted({
                            form_field: 'dob_day'
                        });
                    }
                }
            }
        },
        {
            type: 'select',
            field: dob.mm,
            className: 'dob dob_mo fs-exclude dd-privacy-mask',
            selectAttributes: {
                options: getMonthNamesByLocale(props),
                placeholder: intl.formatMessage({
                    ...messages.monthPlaceholder
                }),
                value: dob.mm.value,
                onChange: handleMonthSelectChange
            }
        },
        {
            type: 'input',
            field: dob.yy,
            className:
                'dob dob_yy no-pad right-field fs-exclude dd-privacy-mask',

            inputAttributes: {
                value: maskedYear,
                placeholder: intl.formatMessage({
                    ...messages.yearPlaceholder
                }),
                pattern: '\\d*',
                maxLength: '4',
                whenBlur: (event) => {
                    if (event?.target?.value?.length > 0) {
                        tracking.ampli.formFieldCompleted({
                            form_field: 'dob_year'
                        });
                    }
                }
            }
        }
    ];

    return (
        <div className="date-of-birth-container">
            <FormField.Multiple
                label={<FormattedMessage {...messages.dob} />}
                fields={dateOfBirthFields}
                customErrorMessage={customerInvalidAgeErrorMessage}
            />
        </div>
    );
}

const mapStateToProps = (state) => ({
    country_code: getCountryCode(state)
});

const intlWrappedDateOfBirth = injectIntl(DateOfBirth);

export default connect(mapStateToProps, null)(intlWrappedDateOfBirth);
